import { render } from "./EventCard.vue?vue&type=template&id=e505dad8&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e505dad8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e505dad8"

export default script